import Swal from 'sweetalert2';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import EnqueteIcon from '../icons/enquetes.svg';

import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';

export default class Enquetes extends Plugin {
    static get requires() {
        return [MediaEmbed];
    }

    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('enquetes', (locale) => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Coloque o ID da Enquete',
                icon: EnqueteIcon,
                tooltip: true,
            });

            // Callback executed once the image is clicked.
            view.on('execute', async () => {
                const { value: id } = await Swal.fire({
                    input: 'text',
                    inputPlaceholder: 'Coloque o ID da Enquete',
                });

                if (id) {
                    editor.model.change(() => {
                        const content = ` <p>[template="enquete" id="${id}"]</p>`;

                        const viewFragment = editor.data.processor.toView(content);
                        const modelFragment = editor.data.toModel(viewFragment);

                        editor.model.insertContent(
                            modelFragment,
                            editor.model.document.selection
                        );
                    });
                }
            });

            return view;
        });
    }
}
